<template>
  <!-- 左侧标签栏，在 mediaHub 和 schedule 路由时显示 [Claude Code] -->
  <div class="left-tabs-wrapper"
       v-if="$route.name === 'mediaHub' || $route.name === 'schedule'">
    <div class="left-tabs">
      <!-- Hub 标签：含视图模式切换弹出层，任意路由 hover 均可展示 [Claude Code] -->
      <div class="tab-item tab-item--with-popup"
           :class="{ 'is-active': $route.name === 'mediaHub' }"
           @click="$router.push({ name: 'mediaHub' }).catch(() => {})">
        <icon-svg icon="#icon-Live"
                  :size="24" />
        <!-- 视图模式弹出层：hover 展示，点击跳转到 mediaHub 并切换视图模式 [Claude Code] -->
        <div class="view-mode-popup"
             @click.stop>
          <!-- 视图模式标题，使用 i18n [Claude Code] -->
          <div class="view-mode-title">{{ $t('viewMode') }}</div>
          <div class="view-mode-item"
               :class="{ active: $route.name === 'mediaHub' && viewMode === 'card' }"
               @click="selectViewMode('card')">
            <i class="iconfont icon-a-gridview view-mode-icon" />
            <span>{{ $t('viewModeCard') }}</span>
          </div>
          <div class="view-mode-item"
               :class="{ active: $route.name === 'mediaHub' && viewMode === 'compact' }"
               @click="selectViewMode('compact')">
            <i class="iconfont icon-a-25 view-mode-icon" />
            <span>{{ $t('viewModeCompact') }}</span>
          </div>
          <div class="view-mode-item"
               :class="{ active: $route.name === 'mediaHub' && viewMode === 'list' }"
               @click="selectViewMode('list')">
            <i class="iconfont icon-List view-mode-icon" />
            <span>{{ $t('viewModeList') }}</span>
          </div>
          <div class="view-mode-item"
               :class="{ active: $route.name === 'mediaHub' && viewMode === 'xyGrid' }"
               @click="selectViewMode('xyGrid')">
            <i class="iconfont icon-xy view-mode-icon" />
            <span>{{ $t('viewModeXYGrid') }}</span>
          </div>
        </div>
      </div>
      <!-- Schedule 标签：点击跳转 /schedule 路由 [Claude Code] -->
      <div class="tab-item"
           :class="{ 'is-active': $route.name === 'schedule' }"
           @click="$router.push({ name: 'schedule' }).catch(() => {})">
        <icon-svg icon="#icon-event1"
                  :size="24" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LeftTabs',
  computed: {
    ...mapState({
      viewMode: 'viewMode'
    })
  },
  methods: {
    // 选择视图模式：设置模式并跳转到 mediaHub 路由 [Claude Code]
    selectViewMode (mode) {
      this.$store.commit('setViewMode', mode)
      if (this.$route.name !== 'mediaHub') {
        this.$router.push({ name: 'mediaHub' })
      }
    }
  }
}
</script>

<style lang="less" scoped>
// 外层容器，提供左侧和上下内边距 [Claude Code]
.left-tabs-wrapper {
  flex-shrink: 0;
  padding: 16px 8px 16px 12px;
}

// 标签列表 [Claude Code]
.left-tabs {
  width: 48px;
  background: #141414;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

// 单个 tab 项 [Claude Code]
.tab-item {
  width: 48px;
  height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 6px;
  color: #666;
  transition: color 0.2s, background 0.2s;
  &:hover {
    background-color: #353535;
  }
  &.is-active {
    background-color: rgba(47, 181, 78, 0.15) !important;
    color: #2fb54e;
  }

  // 含弹出层的 tab 项 [Claude Code]
  &.tab-item--with-popup {
    position: relative;

    // 视图模式弹出层，默认隐藏 [Claude Code]
    .view-mode-popup {
      position: absolute;
      left: calc(100% + 6px);
      top: 0;
      display: none;
      flex-direction: column;
      background: #2c2c2c;
      border: 1px solid #2c2c2c;
      border-radius: 8px;
      padding: 6px 4px;
      z-index: 20000;
      min-width: 130px;

      // 弹出层标题 [Claude Code]
      .view-mode-title {
        font-size: 14px;
        color: #999;
        padding: 0 10px 6px;
        border-bottom: 1px solid #444;
        margin-bottom: 4px;
        white-space: nowrap;
      }

      // 视图模式行：图标 + 文字 [Claude Code]
      .view-mode-item {
        display: flex;
        align-items: center;
        gap: 8px;
        height: 32px;
        padding: 0 10px;
        border-radius: 4px;
        cursor: pointer;
        color: #666;
        font-size: 13px;
        transition: all 0.2s;
        white-space: nowrap;
        .view-mode-icon {
          flex-shrink: 0;
          font-size: 16px;
        }
        &:hover {
          color: #bbb;
          background: rgba(255, 255, 255, 0.06);
        }
        &.active {
          color: @green;
        }
      }
    }

    // 鼠标悬停时显示弹出层 [Claude Code]
    &:hover .view-mode-popup {
      display: flex;
    }
  }
}

// 用伪元素填充 tab 与弹出层之间的空隙，防止鼠标移过时 hover 断开 [Claude Code]
.view-mode-popup::before {
  content: '';
  position: absolute;
  right: 100%;
  top: 0;
  width: 8px;
  height: 100%;
}
</style>
